/**
 * Fetches tags for the Generate Report function, to ensure the tags set remain
 * without being modified when a report is generated.
 */

export async function getTagsFromS3Object(S3, bucket, csvKey) {
    try {
      // Fetch tags from the S3 object
      const tagResponse = await S3.getObjectTagging({
        Bucket: bucket,
        Key: csvKey
      }).promise();
  
      // Initialize default tags
      let tags = {
        status: '',
        uploadedBy: ''
      };
  
      // Iterate over the tags and extract the relevant ones
      tagResponse.TagSet.forEach(tag => {
        if (tag.Key === 'status') {
          tags.status = tag.Value;
        } else if (tag.Key === 'uploadedBy') {
          tags.uploadedBy = tag.Value;
        }
      });
  
      return tags;
    } catch (error) {
      console.error('Failed to retrieve tags:', error);
      throw error;
    }
  }

  